import React from 'react';
import styled from '@emotion/styled';

const HomeContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 2rem;
`;

const ContentBox = styled.div`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(10px);
  padding: 3rem;
  border-radius: 15px;
  width: 800px;
  max-width: calc(100% - 2rem);
  margin: 0 1rem;
  
  @media (max-width: 768px) {
    padding: 2rem;
  }
`;

const Title = styled.h1`
  font-size: 4rem;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  
  span {
    color: #ff3333;
  }
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    word-break: break-word;
    hyphens: auto;
  }
`;

const Subtitle = styled.div`
  font-size: 1.3rem;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 2rem;
  
  &:last-child {
    margin-bottom: 0;
  }
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    line-height: 1.5;
    margin-bottom: 1.5rem;
  }
`;

const PoweredBy = styled.div`
  font-size: 1.3rem;
  margin-bottom: 2rem;
  
  .dash {
    color: white;
  }
  
  .powered {
    color: #ff3333;
  }
  
  .nextcloud {
    color: white;
  }
  
  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 1.5rem;
  }
`;

function Home() {
  return (
    <HomeContainer>
      <ContentBox>
        <Title>
          Red<span>Cloud</span> Storage
        </Title>
        <PoweredBy>
          <span className="dash">-</span>{' '}
          <span className="powered">Powered by</span>{' '}
          <span className="nextcloud">Nextcloud</span>{' '}
          <span className="dash">-</span>
        </PoweredBy>
        <Subtitle>
          Experience secure, reliable, and scalable cloud storage solutions for your business. 
          With cutting-edge technology and unparalleled support, we ensure your data is always safe and accessible when you need it most.
        </Subtitle>
      </ContentBox>
    </HomeContainer>
  );
}

export default Home;
